import { VariantProfileType } from "src/types/VariantProfileType";

function profileNameText(
  name: string,
  surname: string,
  nickname: string,
  profileType: VariantProfileType
) {
  return name &&
    surname &&
    !(name + ` ` + surname === nickname) &&
    profileType === `instructor`
    ? name + ` ` + surname + ` (` + nickname + `)`
    : nickname;
}

export default profileNameText;
